import React, { useState, useEffect } from 'react';
import {
    Spin, Button, Card, Tag, message, Tooltip, Input, Modal, Space, Table, DatePicker
} from 'antd';
import {
  DownloadOutlined
} from '@ant-design/icons';
import 'antd/dist/antd.css';
import Fuse from 'fuse.js';
import _ from 'lodash';
import moment from 'moment';
import * as Service from '../core/Service';
import NavAndSideFrame from '../components/NavAndSideFrame';
import {exportToCSV} from '../core/Main';
import { useTranslation } from 'react-i18next';
import { displayIsActive, displayMoment, displayOrderStatus, displayOrderType } from '../components/table/DisplayMethod';

const { RangePicker } = DatePicker;

const title = `訂單列表`;
const selectedKey = `order_list_sort_by_driver`;
const tableIdName = `order_id`;
const filterableField = [
    'order_date',
    'start_address',
    'end_address'
];

const OrderListSortByDriver = (props) => {
    const {t} = useTranslation();

    const [dataList, setDataList] = useState([]);
    const [unChangeData, setUnChangeData] = useState([]);
    const [modalVisible, setModalVisible] = useState(false);
    const [selectedRecord, setSelectedRecord] = useState({});
    const [isChangingIsActive, setChangingIsActive] = useState(false);
    const [loading, setLoading] = useState(false);
    const [startDate, setStartDate] = useState(moment().subtract(1, 'months').startOf('day'));
    const [endDate, setEndDate] = useState(moment().endOf('day'));

    useEffect(() => {
        getAllData();
    }, [startDate, endDate]);

    const getAllData = async () => {
        let endpoint = `/api/order/list_for_report?start_date=${startDate.unix()}&end_date=${endDate.unix()}`;
        let list = [];
        setLoading(true);
        try {
            list = await Service.call(`GET`, endpoint);
            // list = _.orderBy(data, [`driver_id`], [`asc`]);
            // if (data.errorMessage) list = [];
        } catch (error) {
            console.log(error);
        } finally {
            setDataList(list);
            setUnChangeData(list);
            setLoading(false);
        }
    }

    const setTableHeader = () => {
        let columns = [
            { title: '訂單編號', dataIndex: tableIdName },
            { title: `呼號`, dataIndex: `call_sign`},
            {
                title: '生效狀態',
                dataIndex: 'is_active',
                render: (value) => {
                    return displayIsActive(value, t);
                },
                ellipsis: true
            },
            {
                title: `狀態`,
                dataIndex: `status`,
                render: (value) => {
                    return displayOrderStatus(value, t);
                },
            },
            { 
              title: `訂單種類`, 
              dataIndex: `order_type`,
              render: (value) => {
                return displayOrderType(value, t);
              }
            },
            {
                title: `訂單時間`,
                dataIndex: `order_time`,
                render: (value) => {
                    return displayMoment(value);
                },
                ellipsis: true,
            },
            { title: `司機編號`, dataIndex: `driver_id` },
            { title: `司機電話`, dataIndex: `mobile` },
            { title: `上車地址`, dataIndex: `start_address` },
            { title: `下車地址`, dataIndex: `end_address` },
            { title: `顧客聯絡電話`, dataIndex: `customer_contact_number` },
            { title: `開始時間`, dataIndex: `start_time` ,
            render: (value) => {
              return displayMoment(value);
          },
          ellipsis: true,},
            { title: `結束時間`, dataIndex: `finish_time`,
              render: (value) => {
                  return value ? displayMoment(value) : '-';
              },
              ellipsis: true
            },
            {
                title: '創建時間',
                dataIndex: 'ctime',
                render: (value) => {
                    return displayMoment(value);
                },
                ellipsis: true,
            },
            {
                title: '更新時間',
                dataIndex: 'utime',
                render: (value) => {
                    return displayMoment(value);
                },
                ellipsis: true,
            },
        ];
        return columns;
    }

    const onDateChange = (dates) => {
      setStartDate(dates[0].startOf('day'));
      setEndDate(dates[1].endOf('day'));
    }

    const onClickDownload = async () => {
        const keys = [
            "normal",
            "driver_taken",
            "user_confirmed",
            "finished",
            "cancelled_by_user",
            "cancelled_by_driver",
            "cancelled_by_driver_and_back_to_pool",
            "timeout",
            "others"
          ];

        const _dataList = _.cloneDeep(dataList);
        _dataList.map(data => {
            const value = data.status;
            let statusValue = value < 0 || value >= keys.length ? keys.length-1: value;
            let finalKey = 'order_status.' + keys[statusValue];
            data.status = t(finalKey);
            return data;
        })
        
        await exportToCSV(_dataList, 'driver_report');
    }

    return (
        <NavAndSideFrame {...props} title={title} selectedKey={selectedKey}>
            <Card>
                <Space direction="horizontal">
                  <RangePicker
                    defaultValue={[startDate, endDate]}
                    onCalendarChange={onDateChange}
                    allowClear={false}
                  />
                <Button type="primary" shape="round" icon={<DownloadOutlined />} onClick={onClickDownload}/>
                </Space>
            </Card>
            <Card>
                <Spin spinning={loading}>
                    <Table
                        pagination={{
                            defaultPageSize: 25,
                            showSizeChanger: true,
                            pageSizeOptions: [25, 50, 100, 200, 500]
                        }}

                        scroll={{ x: `max-content` }}
                        dataSource={dataList}
                        columns={setTableHeader()}
                        rowKey={tableIdName}
                    />
                </Spin>
            </Card>
        </NavAndSideFrame>
    );
}

export default OrderListSortByDriver;
